module.exports = __webpack_public_path__ + "img/14.47c7858f.jpeg";